<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="container-panel-margin">
    <div *ngIf="settingsAccount" class="row">
        <div class="col-md-8 offset-md-2">
            <h2>
                User settings for <strong>{{ settingsAccount.login.value }}</strong>
            </h2>

            <div *ngIf="success" class="alert alert-success">{{ 'settings.messages.success' | translate }}</div>

            <winde-alert-error></winde-alert-error>

            <div class="control">
                <div class="control-label">{{ 'settings.form.firstname' | translate }}</div>
                <sui-string-component [config]="settingsAccount.firstName" class="sui-e2e-firstName"></sui-string-component>
            </div>
            <div class="control">
                <div class="control-label">{{ 'settings.form.lastname' | translate }}</div>
                <sui-string-component [config]="settingsAccount.lastName" class="sui-e2e-firstName"></sui-string-component>
            </div>
            <button (click)="save()" windeGreen>
                {{ 'entity.action.save' | translate }}
            </button>
        </div>
    </div>
</div>
